$(document).ready(function(){
    $('.owl-carousel-inicio').owlCarousel({
        dots: true,
        loop:true,
        margin:10,
        nav:false,
        autoplay: true,      // Enable automatic sliding
        autoplayTimeout: 2000, // Time in milliseconds between slides (3s)
        autoplayHoverPause: true,
        responsive:{
            0:{
                items:3
            },
            800:{
                items:6
            },
            1200:{
                items:8
            }
        }
    })
});

$(document).ready(function(){
    $('.owl-categorias').owlCarousel({
        dots: true,
        loop:true,
        margin:10,
        nav:false,
        autoplay: true,      // Enable automatic sliding
        autoplayTimeout: 2000, // Time in milliseconds between slides (3s)
        autoplayHoverPause: true,
        responsive:{
            0:{
                items:2
            },
            767:{
                items:3
            },
            1200:{
                items:5
            }
        }
    })
});


$(document).ready(function(){
    $('.owl-banner').owlCarousel({
        dots: true,
        loop:true,
        margin:10,
        nav:false,
        autoplay: true,      // Enable automatic sliding
        autoplayTimeout: 5000, // Time in milliseconds between slides (3s)
        autoplayHoverPause: true,
        responsive:{
            0:{
                items:1
            },
        }
    })
});



let vueApp;
let section;
document.addEventListener("DOMContentLoaded", () => {
    let section = document.querySelector("#homeSection");
    if (!section) return;

    const vueApp = new Vue({
        el: section,
        data: {
            loading: false,
            // Datos para el autocomplete
            busqueda: '',
            modelos: [],
            modelosFiltrados: [],
            mostrarSugerencias: false,
            modeloSeleccionado: null,
            indiceSugerencia: -1,
            debounceTimer: null,
        },
        computed: {
        },
        methods: {
            onSelectChange() {
                if (this.busqueda.length < 1) return;
                this.getModelos();
                this.modeloSeleccionado = this.modelos.find(m => m.nombre === this.busqueda) || null;
            },
            actualizarMarca(){
                this.getModelos();
            },
            onInput() {
                clearTimeout(this.debounceTimer);

                if (this.busqueda.length < 1) {
                    this.modelosFiltrados = [];
                    this.mostrarSugerencias = false;
                    return;
                }

                this.debounceTimer = setTimeout(() => {
                    this.getModelos();
                }, 300);
            },

            // Obtener modelos del servidor
            getModelos() {
                this.loading = true;

                let params = `buscar=${encodeURIComponent(this.busqueda)}`
                let marcaSelect = document.querySelector("#marcaSelectForm")
                try{
                    if(marcaSelect != null && marcaSelect.value.length > 0){
                        let id = marcaSelect.value.split("-")[0]
                        params += "&marca_id=" + id
                    }
                }catch (error){
                    console.error(error)
                }
                fetch(`/modelos/sugerencias?${params}`)
                    .then(response => response.json())
                    .then(data => {
                        this.modelos = data.modelos || [];
                        this.modelosFiltrados = this.modelos;
                        this.mostrarSugerencias = this.modelos.length > 0;
                        this.indiceSugerencia = -1;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.error('Error al cargar modelos:', error);
                        this.loading = false;
                    });
            },

            seleccionarModelo(modelo) {
                this.modeloSeleccionado = modelo;
                this.busqueda = modelo.nombre;
                this.mostrarSugerencias = false;
                this.indiceSugerencia = -1;
            },

            // Navegación con teclado
            onKeyDown(e) {
                if (!this.mostrarSugerencias || this.modelosFiltrados.length === 0) return;

                switch(e.key) {
                    case 'ArrowDown':
                        e.preventDefault();
                        this.indiceSugerencia = Math.min(
                            this.indiceSugerencia + 1,
                            this.modelosFiltrados.length - 1
                        );
                        break;
                    case 'ArrowUp':
                        e.preventDefault();
                        this.indiceSugerencia = Math.max(this.indiceSugerencia - 1, -1);
                        break;
                    case 'Enter':
                        e.preventDefault();
                        if (this.indiceSugerencia >= 0) {
                            this.seleccionarModelo(this.modelosFiltrados[this.indiceSugerencia]);
                        }
                        break;
                    case 'Escape':
                        this.mostrarSugerencias = false;
                        this.indiceSugerencia = -1;
                        break;
                }
            },

            cerrarSugerencias() {
                setTimeout(() => {
                    this.mostrarSugerencias = false;
                    this.indiceSugerencia = -1;
                }, 200);
            },
        },
    });
});


